import { DoctorInformation, Gender } from './service-data.types';

export interface PaternityServiceInformation {
  doctorInformation: DoctorInformation;
  // The patient is participant 1, their relationship is below
  additionalParticipants: PaternityParticipant[];
  patientHistory: PaternityPatientHistoryInformation;
  parentingTestType: ParentingTestType;
  // Relationship of the patient to the other participants
  relationship: ParticipantRelationship;
  comments: string;
}

export interface PaternityParticipant {
  // Samples reference their participant with this id
  id: string;
  firstName: string;
  lastName: string;
  gender: Gender;
  dateOfBirth: string;
  email: string;
  relationship: ParticipantRelationship;
}

// Asked only for Fraternity
export interface PaternityPatientHistoryInformation {
  isSameBiologicalMother: boolean | null;
  wantToKnow: FraternitySharedParent | null;
}

export enum ParentingTestType {
  Paternity = 'Paternity',
  Maternity = 'Maternity',
  Fraternity = 'Fraternity',
}

export enum ParticipantRelationship {
  Father = 'Father',
  Mother = 'Mother',
  Child = 'Child',
  Sibling = 'Sibling',
}

// Form only, the API gets true / false / null (not available)
export enum SameBiologicalMotherAnswer {
  Yes = 'Yes',
  No = 'No',
  NotAvailable = 'NotAvailable',
}

export enum FraternitySharedParent {
  Father = 'Father',
  Mother = 'Mother',
  BothParents = 'BothParents',
}

// SAMPLE
export interface PaternitySampleServiceInformation {
  participantId: string;
  doctorId: string;
  sampleType: string;
  // Free text when the sample type is "Other"
  otherType: string | null;
}
